import { Skeleton } from '@/shared/components/ui/skeleton'
import { cn } from '@/shared/lib/utils'

type PlaybookViewLoadingStateProps = {
  className?: string
}

export function PlaybookViewLoadingState({
  className,
}: PlaybookViewLoadingStateProps) {
  return (
    <div className={cn('', className)}>
      <div className="mx-auto max-w-3xl">
        <header>
          <Skeleton className="h-8 w-64" />
        </header>

        <section className="mt-8 flex flex-col items-start gap-4">
          <div className="w-full rounded-lg border-2 border-dashed p-6">
            <Skeleton className="mb-2 h-4 w-32" />
            <Skeleton className="mb-2 h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-6 w-20" />
            <Skeleton className="h-6 w-24" />
          </div>
        </section>

        <section className="mt-8 flex flex-col gap-6">
          {/* Loading skeletons for steps */}
          {[1, 2, 3].map((index) => (
            <div key={index} className="rounded-lg border p-6">
              <div className="mb-4 flex items-center gap-3">
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-6 w-48" />
              </div>
              <Skeleton className="mb-4 h-4 w-full" />
              <Skeleton className="mb-4 h-4 w-5/6" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-2/3" />
                <Skeleton className="h-4 w-4/5" />
              </div>
            </div>
          ))}
        </section>

        <section className="mt-8 border-t py-8">
          <div className="mb-6">
            <Skeleton className="mb-4 h-6 w-24" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-4/5" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>

          <div>
            <Skeleton className="mb-4 h-6 w-32" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
            </div>
          </div>
        </section>

        <footer className="mt-8 flex justify-end border-t py-8">
          <Skeleton className="h-9 w-36" />
        </footer>
      </div>
    </div>
  )
}
